<div class="customer-entity-types">
  <mat-form-field>
    <mat-label>{{title}}</mat-label>
    <mat-select [formControl]="formControl">
      @for (option of options; track option) {
        <mat-option [value]="option">{{option?.name ?? ''}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
